import '../agreements.scss';

import { arrayOf } from 'prop-types';
import React from 'react';

import CurrencyFormat from '../../generic/CurrencyFormat';
import StackedBarChart from '../../generic/StackedBarChart';
import getPlannedAndAgreedBudgets from '../../opportunities/utils/get-planned-and-agreed-budgets';
import { agreementShape, opportunityShape } from '../../prop-types';
import {
  agreedBar,
  openBar,
  overspentBar,
  plannedBar,
} from '../utils/get-stacked-bar-chart-items';
import translateBudgetsToProgressBarValues from '../utils/translate-budgets-to-progress-bar-values';

function spendableBudgetLabel(agreedBudget, plannedBudget) {
  return (
    <>
      Used opportunities budget:{' '}
      <CurrencyFormat
        className="font-weight-semi-bold"
        value={agreedBudget + plannedBudget}
        text
      />
    </>
  );
}

function rightLabel(openBudget, overspentBudget) {
  return openBudget > 0 ? (
    <div className="text-success">
      Open :{' '}
      <CurrencyFormat
        className="font-weight-semi-bold"
        value={openBudget}
        text
      />
    </div>
  ) : (
    <div className="text-danger">
      <CurrencyFormat
        className="font-weight-semi-bold"
        value={overspentBudget}
        text
      />
    </div>
  );
}

function markerLabel(totalAgreementBudget) {
  return (
    <div className="c-agreement__total-budget">
      Total agreement budget:{' '}
      <CurrencyFormat
        value={totalAgreementBudget}
        text
        className="font-weight-semi-bold"
      />
    </div>
  );
}

function AgreementBudgetProgress({ opportunities, agreement }) {
  const totalAgreementBudget = agreement.budget;
  const { plannedBudget, agreedBudget } = getPlannedAndAgreedBudgets(
    opportunities,
    agreement.id,
  );

  const overspentBudget = plannedBudget + agreedBudget - totalAgreementBudget;
  const openBudget = totalAgreementBudget - (plannedBudget + agreedBudget);

  const barValues = translateBudgetsToProgressBarValues(
    agreedBudget,
    plannedBudget,
    totalAgreementBudget,
  );

  const items = [
    agreedBar(barValues.agreed),
    plannedBar(barValues.planned),
    openBar(barValues.open),
    overspentBar(barValues.overspent),
  ];

  return (
    <StackedBarChart
      items={items}
      id={`agreement-${agreement.id}-progress`}
      marker={{
        label: markerLabel(totalAgreementBudget),
        value: totalAgreementBudget,
      }}
      leftLabel={spendableBudgetLabel(agreedBudget, plannedBudget)}
      rightLabel={rightLabel(openBudget, overspentBudget)}
    />
  );
}

AgreementBudgetProgress.propTypes = {
  opportunities: arrayOf(opportunityShape.isRequired).isRequired,
  agreement: agreementShape.isRequired,
};

export default AgreementBudgetProgress;
